import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_ledger_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  namespace:fromDatatype.VarcharDatatypeInterface;
  module_guid:fromDatatype.GuidDataFieldInterface;
  applet_guid:fromDatatype.GuidDataFieldInterface;
  acl_config:fromDatatype.JsonDatatypeInterface;
  acl_policy:fromDatatype.JsonDatatypeInterface;
  name:fromDatatype.VarcharDatatypeInterface;
  code:fromDatatype.VarcharDatatypeInterface;
  ccy_code:fromDatatype.VarcharDatatypeInterface;
  chart_of_acc_guid:fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mst_ledger_hdr_RowClass
  implements bl_fi_mst_ledger_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    module_guid:fromDatatype.GuidDataFieldInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    name:fromDatatype.VarcharDatatypeInterface;
    code:fromDatatype.VarcharDatatypeInterface;
    ccy_code:fromDatatype.VarcharDatatypeInterface;
    chart_of_acc_guid:fromDatatype.GuidDataFieldInterface;
}
